import {SxProps} from '@mui/material';

export const COMMON_STYLES = {
  chartTitle: {
    p: 0,
    height: '22px',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '19px',
    color: '#464255',
    flexShrink: 0,
  },
  chartSelect: {
    m: 0,
    height: '26px',
    minHeight: '26px',
    background: '#FFFFFF',
    borderRadius: '4px',

    '& .MuiSelect-select': {
      top: '-2px',
    },
  },
  chartSelectLabel: {
    top: '-6px',
    fontSize: '0.8rem',

    '&.Mui-focused, &.MuiFormLabel-filled': {
      top: '-2px',
    },
  },
} as const satisfies SxProps;

export const TITLE_PL: Record<string, SxProps> = {
  common: {pl: '46px'},
  part: {pl: '14px'},
} as const;
